import { createTheme, ThemeOptions } from "@mui/material/styles";

const commonComponents: ThemeOptions["components"] = {
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: "none", // Remove default MUI dark mode paper gradient
      },
    },
  },
};

export const lightTheme = createTheme({
  palette: {
    mode: "light",
  },
  components: commonComponents,
});

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#121212",
      paper: "#1e1e1e",
    },
  },
  components: {
    ...commonComponents,
    MuiCssBaseline: {
      styleOverrides: {
        // Override link colors globally in dark mode
        "a": {
          color: "#90caf9",
        },
        "a:visited": {
          color: "#b39ddb",
        },
      },
    },
  },
});
